var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Menu } from "semantic-ui-react";
import { Plexity, ProKitConfig } from "../../KitDeserializer";
import { ProtocolTypeEnum } from "./EditKitForm";
var ProKitDetectForm = /** @class */ (function (_super) {
    __extends(ProKitDetectForm, _super);
    function ProKitDetectForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onEnzymeCompatibilityChange = function (_, data) {
            var cc = data.index;
            var selectedEnzyme = _this.props.proAmps
                .filter(function (c) {
                if (_this.props.protocolType != null) {
                    return c.platformCompatibility.find(function (p) { var _a; return p.id === ((_a = _this.props.protocolType) === null || _a === void 0 ? void 0 : _a.id); }) != null;
                }
                else {
                    return true;
                }
            })
                .find(function (c) { return c.id === cc; });
            _this.props.onProDetectStateChange(function () { return ({
                enzymeCompatibility: selectedEnzyme
            }); }, _this.props.channel, function () {
                if (!checkChromogenCompatibility(_this.props.proKitDetectState.chromogen, _this.props.protocolType, selectedEnzyme)) {
                    _this.props.onProDetectStateChange(function () { return ({
                        chromogen: undefined
                    }); }, _this.props.channel, _this.props.onUserSelection);
                }
                else {
                    _this.props.onUserSelection();
                }
            });
        };
        _this.onChromogenChange = function (_, data) {
            var cc = data.name;
            if (cc === 'NONE') {
                _this.props.onProDetectStateChange(function () { return ({
                    chromogen: {
                        id: 'NONE',
                        label: 'NONE',
                        enzymeCompatibility: '',
                        bufferCompatibility: { id: 'NONE', label: 'NONE' },
                        platformCompatibility: []
                    }
                }); }, _this.props.channel, _this.props.onUserSelection);
            }
            else {
                var selectedChromogen_1 = _this.props.catalog.proChromogens.chromogens
                    .filter(function (c) {
                    return checkChromogenCompatibility(c, _this.props.protocolType, _this.props.proKitDetectState.enzymeCompatibility);
                })
                    .find(function (c) { return c.id === cc; });
                _this.props.onProDetectStateChange(function () { return ({
                    chromogen: selectedChromogen_1
                }); }, _this.props.channel, _this.props.onUserSelection);
            }
        };
        return _this;
    }
    ProKitDetectForm.prototype.render = function () {
        var _this = this;
        var protocolType = this.props.protocolType;
        var enzymeCompatibility = this.props.proKitDetectState.enzymeCompatibility;
        var chromogen = this.props.proKitDetectState.chromogen;
        var kitConfiguration = this.props.kitConfiguration;
        var protocols = this.props.catalog.proPlatforms;
        var ampCatalog = this.props.proAmps;
        var enzymes;
        if (protocolType != null) {
            enzymes = findValidConfigs(ampCatalog, protocolType);
        }
        else {
            // If the protocol type is not selected show the leica configurations as the default until the user
            // selects a protocol type
            enzymes = findValidConfigs(ampCatalog, protocols.find(function (p) { return p.id === ProtocolTypeEnum.LEICA; }));
        }
        var enzymeCss = enzymes.length === 3 ? "configure-selection"
            : (enzymes.length === 2 ? "half-configure-selection" : "full-configure-selection");
        return React.createElement(React.Fragment, null,
            React.createElement(Grid, { className: this.props.disabled ? "disabled" : "", columns: 4, verticalAlign: "middle", textAlign: "center", padded: false },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                        React.createElement("p", { className: 'ish-subheader-tag' }, "Enzyme")),
                    React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                        React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true }, enzymes.sort(function (c) {
                            if (c.label === "HRP") {
                                return -1;
                            }
                            else if (c.label === "AP") {
                                return 0;
                            }
                            else {
                                return 1;
                            }
                        }).map(function (c, index) {
                            return React.createElement(React.Fragment, { key: index },
                                React.createElement(Menu.Item, { className: (enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.id) === c.id ? enzymeCss + " selected-ish" : "" + enzymeCss, index: c.id, key: index, onClick: _this.onEnzymeCompatibilityChange, fitted: true, active: (enzymeCompatibility === null || enzymeCompatibility === void 0 ? void 0 : enzymeCompatibility.id) === c.id },
                                    React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                        React.createElement("p", { className: enzymeCompatibility === c ? 'ish-p-tag selected-ish' : 'ish-p-tag' }, c.label),
                                        enzymeLabels(c, enzymeCompatibility === c))));
                        }))),
                    React.createElement(Grid.Column, { width: 1 }))),
            ((kitConfiguration === ProKitConfig.ProbeDetect || kitConfiguration === ProKitConfig.DetectOnly) &&
                (chromogenCompatiblePlatform(this.props.catalog.proChromogens.chromogens, protocolType) && (protocolType === null || protocolType === void 0 ? void 0 : protocolType.id) != null)
                && enzymeCompatibility !== undefined && this.props.plexity === Plexity.OnePlex) &&
                React.createElement(React.Fragment, null,
                    React.createElement(Grid, { columns: 5, verticalAlign: "middle", textAlign: "center", padded: false },
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: 3, textAlign: "right" },
                                React.createElement("p", { className: 'ish-subheader-tag' }, "Chromogen"),
                                React.createElement("p", { className: 'ish-sec-p-tag' }, "(+$20/slide)")),
                            React.createElement(Grid.Column, { width: 12, textAlign: "center" },
                                React.createElement(Menu, { compact: true, widths: 12, className: "outer-config-box", borderless: true },
                                    this.props.catalog.proChromogens.chromogens.map(function (c, index) {
                                        return React.createElement(Menu.Item, { className: checkChromogenCompatibility(c, protocolType, enzymeCompatibility)
                                                ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "quarter-configure-selection selected-ish" : "quarter-configure-selection")
                                                : "quarter-configure-selection disabled-cr", onClick: _this.onChromogenChange, name: c.id, key: index },
                                            React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                                React.createElement("p", { className: checkChromogenCompatibility(c, protocolType, enzymeCompatibility)
                                                        ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "ish-p-tag selected-ish" : "ish-p-tag")
                                                        : "ish-p-tag disabled-cr" }, c.label),
                                                React.createElement("p", { className: checkChromogenCompatibility(c, protocolType, enzymeCompatibility)
                                                        ? ((chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === c.id ? "ish-sec-p-tag selected-ish" : "ish-sec-p-tag")
                                                        : "ish-sec-p-tag disabled-cr" }, "(" + c.enzymeCompatibility + " compatible)")));
                                    }),
                                    React.createElement(Menu.Item, { className: (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === 'NONE' ? "quarter-configure-selection selected-ish" : "quarter-configure-selection", name: 'NONE', onClick: this.onChromogenChange },
                                        React.createElement("p", { className: (chromogen === null || chromogen === void 0 ? void 0 : chromogen.id) === 'NONE' ? "ish-p-tag selected-ish" : "ish-p-tag" }, "None")))),
                            React.createElement(Grid.Column, { width: 1 })))));
    };
    return ProKitDetectForm;
}(React.PureComponent));
export default ProKitDetectForm;
var findValidConfigs = function (proAmpConfig, protocolType) {
    return proAmpConfig
        .filter(function (c) { return c.platformCompatibility.find(function (pc) { return pc.id === protocolType.id; }) != null; });
};
export var checkChromogenCompatibility = function (chromogen, protocol, enzyme) {
    if (chromogen == null || protocol == null || enzyme == null) {
        return false;
    }
    else {
        return chromogen.platformCompatibility.some(function (p) { return p.id === protocol.id; }) &&
            (enzyme.label === "HRP & AP" || enzyme.label === chromogen.enzymeCompatibility);
    }
};
/**
 * Determines whether the provided newPlatform is incompatible with chromogens or not
 * @param chromogen
 * @param platform the Protocol type of the kit
 * @return true if compatible and false if incompatible
 */
export var chromogenCompatiblePlatform = function (chromogen, platform) {
    return chromogen.some(function (c) {
        return c.platformCompatibility.some(function (p) {
            return p.id === (platform === null || platform === void 0 ? void 0 : platform.id);
        });
    });
};
export var enzymeLabels = function (config, selected) {
    if (config.enzyme.id === "HRP_AP") {
        return React.createElement(React.Fragment, null,
            React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(+$15/slide)"));
    }
    else if (config.enzyme.id === "AP") {
        return React.createElement(React.Fragment, null,
            React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., Fast Red)"));
    }
    else if (config.enzyme.id === "HRP") {
        return React.createElement(React.Fragment, null,
            React.createElement("p", { className: selected ? 'ish-sec-p-tag selected-ish' : 'ish-sec-p-tag' }, "(e.g., DAB, TSA Fluors)"));
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
//# sourceMappingURL=ProKitDetectForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/ProKitDetectForm.js
// module id = 185
// module chunks = 0